import React from 'react'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import styled from 'styled-components'
import { useOverflowObserver } from 'hooks/useOverflowObserver'

const StyledTextContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  color: ${({ color }: { color: string }) => color};
`

const LongTextContainer = ({
  color,
  children,
  tooltipContent
}: {
  color: string
  children: React.ReactNode
  tooltipContent: React.ReactNode
}) => {
  const mode = useDisplayTheme() as Theme

  const { isOverflowY, targetRef } = useOverflowObserver()

  const handleRef = (
    setTooltipTriggerRef: React.Dispatch<React.SetStateAction<HTMLElement | null>>
  ) => (StyledNameContainerRef: HTMLDivElement) => {
    targetRef.current = StyledNameContainerRef
    setTooltipTriggerRef(StyledNameContainerRef)
  }

  return (
    <Tooltip
      enabled={isOverflowY}
      content={tooltipContent}
      mode={mode}
      callbackRefCreator={handleRef}>
      <StyledTextContainer color={color} ref={targetRef as React.MutableRefObject<HTMLDivElement>}>
        {children}
      </StyledTextContainer>
    </Tooltip>
  )
}

export default LongTextContainer
